import { Link, useLocation } from 'react-router-dom';

import type { Route } from '@api/app_context/types';

import { LockIcon } from '../../icons';

import styles from './_index.module.scss';

export interface NavigationProps {
  routes: Array<Route & { is_active?: boolean; to: string }>;
}

const Navigation = ({ routes }: NavigationProps) => {
  const { pathname } = useLocation();

  return (
    <ul className={styles['navigation']}>
      {routes.map((route, routeIndex) => {
        const url = route?.to;
        const isActive = pathname.includes(url) || route?.is_active ? styles['is-active'] : '';
        const isDisabled = route?.is_locked ? styles['is-disabled'] : '';

        return route?.is_hidden ? null : (
          <li
            className={`${isActive} ${isDisabled}`}
            data-testid={`${route?.label?.toLowerCase().replace(/\s+/g, '-')}-navigation`}
            key={routeIndex}
          >
            <Link to={url}>{route?.label}</Link>
            {route?.is_locked && <LockIcon />}
          </li>
        );
      })}
    </ul>
  );
};

export default Navigation;
